import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ChevronsRight = createReactComponent("ChevronsRight", ["svg", defaultAttributes, [["polyline", {
  points: "13 17 18 12 13 7",
  key: "8cl2ko"
}], ["polyline", {
  points: "6 17 11 12 6 7",
  key: "6q5tup"
}]]]);
export default ChevronsRight;